/** @format */
import { QuoteFormVariant } from './constants';

export const getQuoteFormVariant = (
    isInlineQuoteEditing: boolean
): QuoteFormVariant =>
    isInlineQuoteEditing
        ? QuoteFormVariant.NEW_QUOTE_FORM
        : QuoteFormVariant.OLD_QUOTE_FORM;
